import { render, staticRenderFns } from "./PayOpenInvoicesView.vue?vue&type=template&id=298d8a78&scoped=true&"
import script from "./PayOpenInvoicesView.vue?vue&type=script&lang=ts&"
export * from "./PayOpenInvoicesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298d8a78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
